import React from "react"
import styled from "@emotion/styled"

const DisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10vh 1vw 5vh;
`

const ServiceProviderNotice = styled.div`
  width: 100%;
  max-width: 80vw;
  margin: 1.25rem auto 0;
  color: #1f2425;
  font-family: Roboto;
  font-size: 0.7vw;
  font-weight: 500;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-align: center;

  @media (max-width: 425px) {
    width: 85%;
    margin-top: 1rem;
  }
`

const Text = styled.p`
  text-align: center;
  max-width: 72vw;
  font-family: Roboto;
  font-size: 0.6vw;
  color: #1A2225;
  letter-spacing: 1.3px;
  @media (max-width: 424px) {
    padding: 0 1rem;
  }
  @media (max-width: 1024px) {
    text-align: center;
    max-width: 676px;
  }
`

const DisclaimerV2 = () => (
  <DisclaimerText>
    <ServiceProviderNotice>
      La entidad prestadora del servicio dependerá del país de residencia del cliente.
      En Chile, los servicios son prestados exclusivamente por Capitaria Latam SpA.
      En otros países, los servicios son prestados por KT Financial Group Limited.
    </ServiceProviderNotice>
    <br />
    <Text>
      En los mercados financieros se generan rápidos movimientos que pueden
      conllevar a un elevado riesgo de pérdidas. Por esta razón, participar
      activamente en estos mercados con apalancamiento financiero, solo es
      aconsejable para aquellos participantes que puedan asumir dicho riesgo.
      Cualquier análisis o consejo sobre el mercado comunicado a través de
      www.capitaria.com o de algún correo electrónico con este remitente, debe ser
      considerado como una opinión, y nunca como una garantía o recomendación de inversión.
      En ningún caso y bajo ningún concepto, Capitaria se hace responsable de las
      posibles pérdidas incurridas por nuestros clientes. Todo cliente potencial de
      Capitaria debe tener en cuenta que su capital puede verse tanto incrementado como
      disminuido, no debiendo participar en este mercado sin antes considerar si
      esta manera de operar es la adecuada para él, en función de su situación
      financiera. Los clientes potenciales deben también tener en cuenta que no se
      pueden garantizar los resultados de las operaciones, y que los resultados
      obtenidos en el pasado no garantizan resultados futuros. El trading implica
      un alto riesgo y un cliente puede perder una cantidad sustancial de dinero,
      no importando qué método utilice. Capitaria ofrece instrumentos incluidos en
      la Ley 21.521 - Ley Fintec. Infórmese sobre los riesgos relacionados a esa
      actividad en www.capitaria.com. Capitaria no es asesor de inversiones según la Ley 21.521.
    </Text>
  </DisclaimerText>
)

export default DisclaimerV2
